angular.module('TInv.dir', []
).directive('alias', function ($parse) {
    return {
        restrict: 'A',
        compile: function() {
            return {
                pre: function(scope, element, attrs) {
                    var func = $parse(attrs.alias + ' = ' + attrs.aliasVal);
                    scope.$watch(attrs.aliasVal, function () {
                        func(scope);
                    });
                }
            };
        },
    };
}).directive('panel', function () {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            heading: '@'
        },
        template:
            '<div class="panel panel-default">'+
              '<div class="panel-heading">{{heading}}</div>'+
              '<div class="panel-body" ng-transclude></div>'+
            '</div>'
    };
}).directive('uibAccordionGroup', function () {
    // customize to add recursive validation support
    return {
        restrict: 'A',
        link: function (scope, element) {
            scope.$on('invoiceChanged', function () {
                // search a <form> element that Angular did not validate
                // aplpy proper Bootstrap CSS on parent
                if (element[0].querySelector('.ng-invalid'))
                    element.addClass('panel-has-error');
                else
                    element.removeClass('panel-has-error');
            });
        }
    };
}).directive('formGroup', function () {
    // inspired from: http://stackoverflow.com/a/22658021/166524
    var uniqueId = 0;
    return {
        restrict: 'E',
        require: '^form',
        transclude: true,
        template:
            '<div class="form-group" ng-transclude></div>',
        link: function (scope, element, attr) {
            // search a <form> element to connect the <label> to
            var label = angular.element('<label>').text(attr.name),
                el = element[0].querySelector('input, select, button, textarea, progress');
            if (el) {
                if (!el.id) // 'id' missing, will generate an (hopefully) unique one
                    el.id = 'fgAutoId-' + (++uniqueId);
                label.attr('for', el.id);
            }
            element.prepend(label);
            attr.$observe('name', value => { label.text(value); });
            scope.$on('invoiceChanged', function () {
                // search a <form> element that Angular did not validate
                // apply proper Bootstrap CSS on parent
                if (element[0].querySelector('.ng-invalid'))
                    element.addClass('has-error');
                else
                    element.removeClass('has-error');
            });
        }
    };
}).directive('dropMenu', function () {
    // inspired from from: http://plnkr.co/edit/ECdIBX6GGQycw1tg5Xw7?p=preview
    return {
        restrict: 'E',
        scope: {
            model: '=',
            list: '=',
        },
        template:
            '<div class="btn-group" uib-dropdown>' +
              '<button type="button" class="btn btn-primary" uib-dropdown-toggle>' +
                '{{label}} <span class="caret"></span>' +
              '</button>' +
              '<ul class="dropdown-menu" uib-dropdown-menu role="menu">' +
                '<li role="menuitem" ng-repeat="(key, value) in list"><a href="" ng-click="setModel(key)">{{value}}</a></li>' +
              '</ul>' +
            '</div>',
        controller: function ($scope) {
            $scope.$watch('model', function () {
                $scope.label = $scope.list[$scope.model] || 'scegli…';
            });
            $scope.setModel = function (key) {
                $scope.selected = true;
                $scope.model = key;
                $scope.label = $scope.list[key];
            };
        }
    };
}).directive('date8601', function ($filter) {
    return {
        restrict: 'E',
        scope: {
            model: '=', //TODO: check if we could simply use ngModel as a name
        },
        template:
            '<div class="input-group">' +
              '<input ng-model="myModel" type="text" class="form-control" size="10" uib-datepicker-popup="yyyy-MM-dd" is-open="opened" datepicker-options="dateOptions" ng-required="true" close-text="Chiudi">' +
              '<span class="input-group-btn">' +
                '<button type="button" class="btn btn-default"><i class="glyphicon glyphicon-calendar"></i></button>' +
              '</span>' +
            '</div>',
        controller: function ($scope) {
            $scope.opened = false;
        },
        link: function (scope, element) {
            scope.dateOptions = {
                startingDay: 1
            };
            scope.$watch('model', function () {
                scope.myModel = scope.model ? new Date(scope.model) : null; // possible timezone issues west of Greenwitch
            });
            scope.$watch('myModel', function () {
                scope.model = $filter('date')(scope.myModel, 'yyyy-MM-dd');
            });
            element.find('button').bind('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                scope.opened = true;
                scope.$apply();
            });
        }
    };
}).directive('datetinv', function ($filter) {
    return {
        restrict: 'E',
        scope: {
            model: '=', //TODO: check if we could simply use ngModel as a name
        },
        template:
            '<div class="input-group">' +
              '<input ng-model="myModel" type="text" class="form-control" size="10" uib-datepicker-popup="yyyy-MM-dd" is-open="opened" datepicker-options="dateOptions" ng-required="true" close-text="Chiudi">' +
              '<span class="input-group-btn">' +
                '<button type="button" class="btn btn-default"><i class="glyphicon glyphicon-calendar"></i></button>' +
              '</span>' +
            '</div>',
        controller: function ($scope) {
            $scope.opened = false;
        },
        link: function (scope, element) {
            var today = new Date();
            var min = new Date();
            min.setDate(min.getDate()-(365*3));// 3 years back
            scope.dateOptions = {
                startingDay: 1,
                minDate : min.toISOString(),
                maxDate : today.toISOString()
            };
            scope.$watch('model', function () {
                scope.myModel = scope.model ? new Date(scope.model) : null; // possible timezone issues west of Greenwitch
            });
            scope.$watch('myModel', function () {
                scope.model = $filter('date')(scope.myModel, 'yyyy-MM-dd');
            });
            element.find('button').bind('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                scope.opened = true;
                scope.$apply();
            });
        }
    };
}).directive('currency', function () {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function (scope, element, attrs, ctrl) {
            element.bind('blur', function () {
                ctrl.$viewValue = ctrl.$modelValue.toFixed(8).replace(/([.][0-9]{2}([0-9]*[1-9])?)0+$/, '$1');
                ctrl.$render();
            });
            //ctrl.$parsers.push(round2); //was this needed? seems to work anyways
        }
    };
}).directive('tail', function () {
    // inspired to: https://stackoverflow.com/a/25464509/166524
    return {
        restrict: 'A',
        link: function (scope, element) {
            var e = element[0];
            scope.$watch(function () {
                return e.textContent;
            }, function () {
                e.scrollTop = e.scrollHeight;
            });
        }
    };
}).filter('euro', function () {
    return function (input) {
        var str = Number(input).toFixed(2).replace('.', ',');
        /*TODO: add narrow spaces \u202F
        0.00
        10.00
        100.00
        1 000.00
        10 000.00
        100 000.00
        1 000 000.00
        */
        str += '\u00A0€';
        return str;
    };
}).filter('lang', function () {
    return function (input, lang) {
        return input[lang|0] || input[0];
    };
});
